import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';
import { Banner } from '../interfaces/banner.interface';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { Camapign, CamapignRegisterScan, CamapignScanDetails, CamapignScans, CardStatisticsResponse, PartnerStatisticResponse } from '../interfaces/campaigns.interface';

@Injectable({
  providedIn: 'root'
})
export class CamapignScanService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('campaign-scan');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  getScans(params?: any): Observable<GenericResponseWithTotal<CamapignScans>> {
    params = params || {};
    return this.http.get<GenericResponseWithTotal<CamapignScans>>(this.apiUrl, { 
      params: this.dataProcess.fitlerParams(params) 
    });
  }

  getScanDetails(params?: any): Observable<CamapignScanDetails> {
    params = params || {};
    return this.http.get<CamapignScanDetails>(this.apiUrl + '/scan-details', { 
      params: this.dataProcess.fitlerParams(params) 
    });
  }

  processScanning(scanDetails: CamapignRegisterScan): Observable<any> {

    return this.http.post<CamapignRegisterScan>(this.apiUrl, scanDetails);
  }

  getCardStatistics(params?: any): Observable<CardStatisticsResponse> {
    params = params || {};
    return this.http.get<CardStatisticsResponse>(`${this.apiUrl}/card-statistics`, {
      params: this.dataProcess.fitlerParams(params)
    });
  }

  getPartnerStatistics(params?: any): Observable<PartnerStatisticResponse> {
    params = params || {};
    return this.http.get<PartnerStatisticResponse>(`${this.apiUrl}/partner-statistics`, {
      params: this.dataProcess.fitlerParams(params)
    });
  }

}

